interface Photo {
  id: string;
  photo_url: string;
  sort_order: number;
}

interface Props {
  photos: Photo[];
  selectedId: string | null;
  onSelect: (id: string | null) => void;
  accentColor: string;
}

export default function PhotoPicker({ photos, selectedId, onSelect, accentColor }: Props) {
  if (photos.length === 0) return null;

  return (
    <div className="space-y-2">
      <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">
        Anclar en foto (opcional)
      </p>
      <p className="text-xs text-slate-400">Elige una foto para anclar tu mensaje</p>
      <div className="grid grid-cols-3 gap-2">
        <button
          type="button"
          onClick={() => onSelect(null)}
          className={`aspect-square rounded-xl border-2 flex items-center justify-center transition-all cursor-pointer ${
            selectedId === null
              ? "border-slate-400 bg-slate-100"
              : "border-transparent bg-slate-100 hover:border-slate-200"
          }`}
        >
          <div className="text-center">
            <i className="ri-layout-masonry-line text-slate-400 text-lg block mb-0.5"></i>
            <span className="text-[10px] text-slate-400 font-medium">Sin foto</span>
          </div>
        </button>
        {photos.map((photo) => (
          <button
            key={photo.id}
            type="button"
            onClick={() => onSelect(photo.id === selectedId ? null : photo.id)}
            className="relative aspect-square rounded-xl overflow-hidden border-2 transition-all cursor-pointer"
            style={{
              borderColor: photo.id === selectedId ? accentColor : "transparent",
              outline: photo.id === selectedId ? `2px solid ${accentColor}30` : "none",
            }}
          >
            <img
              src={photo.photo_url}
              alt=""
              className="w-full h-full object-cover object-top"
            />
            {photo.id === selectedId && (
              <div
                className="absolute inset-0 flex items-center justify-center"
                style={{ backgroundColor: accentColor + "30" }}
              >
                <div
                  className="w-7 h-7 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: accentColor }}
                >
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}